import * as moment from 'moment';

// TODO: check app props for a forced different now
export default function() {
	return moment();
}